export default {
    menu_actions_rename_dashboard: "Rename Dashboard",
    menu_actions_delete_dashboard: "Delete Dashboard",
    menu_actions_shared_with_me: "Shared with me",
    menu_actions_reader: "Reader",
    menu_actions_editor: "Editor",
    menu_actions_share: "Share",
    menu_actions_share_success_message: "The Dashboard has been shared",
    menu_actions_share_dashboard: "Share Dashboard",
}